import { Card } from "@/ui/components/primitives/card";
import type { WalletBalances } from "@/services/api/services/merchant-dashboard";

interface WalletBalanceHeroProps {
  wallet: WalletBalances;
  isLoading?: boolean;
}

export function WalletBalanceHero({ wallet, isLoading }: WalletBalanceHeroProps) {
  if (isLoading) {
    return (
      <Card className="p-6 sm:p-8 bg-gradient-to-br from-primary/5 to-primary/10 border-primary/20">
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
          {[1, 2, 3].map((i) => (
            <div key={i} className="space-y-2">
              <div className="h-4 w-32 bg-muted rounded animate-pulse" />
              <div className="h-10 w-40 bg-muted rounded animate-pulse" />
            </div>
          ))}
        </div>
      </Card>
    );
  }

  // Provide default values if wallet is undefined
  const walletData = wallet || {
    availableBalance: 0,
    reservedBalance: 0,
    totalBalance: 0,
    currency: 'INR'
  };

  return (
    <Card className="p-6 sm:p-8 bg-gradient-to-br from-primary/5 to-primary/10 border-primary/20">
      <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
        <div>
          <p className="text-sm text-muted-foreground mb-2">Available Balance</p>
          <p className="text-4xl font-semibold text-foreground">
            ₹{(walletData.availableBalance || 0).toLocaleString()}
          </p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground mb-2">Reserved Balance</p>
          <p className="text-3xl font-semibold text-warning">
            ₹{(walletData.reservedBalance || 0).toLocaleString()}
          </p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground mb-2">Total Balance</p>
          <p className="text-3xl font-semibold text-foreground">
            ₹{(walletData.totalBalance || 0).toLocaleString()}
          </p>
        </div>
      </div>
    </Card>
  );
}